import type { ApiHubSpot } from '../../../api/hubspot'

interface Values {
	lead: ApiHubSpot.Options[]
	sub?: ApiHubSpot.Options
}

function isSameArray<El>(firsts: El[], seconds: El[]) {
	if (firsts.length !== seconds.length) {
		return false
	}

	return firsts.length === 0 || firsts.every((el, i) => el === seconds[i])
}

const isSame = (updated: Values, old: Values) =>
	updated.sub === old.sub && isSameArray(updated.lead, old.lead)

function adaptToServer({ lead, sub }: Values): ApiHubSpot.StaticField[] {
	const fields: ApiHubSpot.StaticField[] = []

	fields.push({
		key: 'lead_source',
		values: lead.map(el => el.value)
	})

	if (sub) {
		fields.push({
			key: 'contact_sub_source',
			values: [sub.value]
		})
	}

	return fields
}

function adaptToState(
	fields: ApiHubSpot.StaticField[],
	sources: ApiHubSpot.Options[],
	subSources: ApiHubSpot.Options[]
): Values {
	const lead = fields.find(field => field.key === 'lead_source')?.values ?? []
	const sub =
		fields.find(field => field.key === 'contact_sub_source')?.values[0] ?? ''

	return {
		lead: lead.flatMap(el => sources.find(item => item.value === el) ?? []),
		sub: subSources.find(el => el.value === sub)
	}
}

export { adaptToServer, adaptToState, isSame }

export type { Values }
